export function hasData(seriesData) {
    return seriesData.some(value => value > 0);
}

export function autoHideEmptySeries(series) {
    const hiddenIndexes = new Set();
    series.forEach((seriesItem, index) => {
        if (!hasData(seriesItem.data)) {
            hiddenIndexes.add(index);
        }
    });
    return hiddenIndexes;
}
